import { useRef, useState } from "react";
import { Box, Popover, Tooltip, Typography } from "@material-ui/core";
import { get } from "lodash";
import { useStyles } from "../styles";
import DefaultTargetImg from "Assets/images/target-default-image.svg";

const AssignedToTargets = ({ colProps }) => {
  const classes = useStyles();
  const containerRef = useRef();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClick = (event, data) => {
    if (get(colProps, "dataItem.assignedToTargets", "") > 0) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const targetListItem = (logo, title) => (
    <Box p={0.5} display="flex" alignItems="center">
      <img
        src={logo || DefaultTargetImg}
        alt="coverImage"
        className={classes.coverImg}
      />
      <Box ml={1}>
        <Tooltip title={title}>
          <Typography
            variant="subtitle2"
            className={`${classes.targetTitle} font-12`}
            noWrap="true"
          >
            {title}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  );

  return (
    <td ref={containerRef}>
      <Box display={"flex"} justifyContent={"center"}>
        <Typography
          variant="subtitle"
          noWrap="true"
          data-testid="handleClick"
          onClick={(e) => handleClick(e, colProps)}
        >
          {`${get(colProps, "dataItem.assignedToTargets", "")} targets`}
        </Typography>
        <Popover
          id={id}
          open={open}
          className={classes.popover}
          anchorEl={anchorEl}
          data-testId="add"
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Box display={"flex"} flexDirection={"column"} p={1}>
            {(get(colProps, "dataItem.assignedToTargetsDetails", []) || []).map(
              (target) => {
                const logo = (get(target, "logo.fileName", "") || "").length
                  ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
                      target,
                      "logo.fileName",
                      ""
                    )}`
                  : "";

                return targetListItem(logo, get(target, "title", ""));
              }
            )}
          </Box>
        </Popover>
      </Box>
    </td>
  );
};

export default AssignedToTargets;
